"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _reactNativeUiLib = require("react-native-ui-lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var CustomModal = function CustomModal(_ref) {
  var visible = _ref.visible,
    onClose = _ref.onClose,
    title = _ref.title,
    children = _ref.children,
    width = _ref.width,
    height = _ref.height,
    backgroundColor = _ref.backgroundColor,
    overlayColor = _ref.overlayColor,
    style = _ref.style;
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    style: [{
      alignItems: 'center',
      height: height || '100%',
      width: '100%'
    }, style]
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    useSafeArea: true,
    style: {
      width: '100%',
      height: '100%',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, {
    style: [styles.overlay, {
      backgroundColor: overlayColor ? overlayColor : _reactNativeUiLib.Colors.rgba(_reactNativeUiLib.Colors.black, 0.5)
    }],
    onPress: function onPress() {
      onClose();
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    row: true,
    style: {
      width: width || '100%',
      zIndex: 9999
      // margin : 20,
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    style: {
      flex: 1,
      zIndex: 99
    }
  }, children))));
};
var styles = _reactNative.StyleSheet.create({
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 0
  },
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    zIndex: 0
  },
  modal: {
    borderRadius: 5,
    padding: 10
  },
  title: {
    fontWeight: 'bold',
    fontSize: 18,
    marginBottom: 10
  }
});
var _default = exports["default"] = CustomModal;